<template>
    <div class="table">
        <!-- 头部 -->
        <div class="crumbs">
            <Breadcrumb v-bind:menuList="menuList"></Breadcrumb>
        </div>
        <!-- 表格内容 -->
        <div class="container">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="卡券编码:">
                    <el-input v-model="queryParams.code" placeholder="请输入卡券编码" clearable></el-input>
                </el-form-item>
                <el-form-item label="状态:">
                    <el-select v-model="queryParams.state" placeholder="请选择状态" clearable @change="changeQuery">
                        <el-option label="无效" :value="0"></el-option>
                        <el-option label="有效" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="使用状态:">
                    <el-select v-model="queryParams.used_state" placeholder="请选择卡券使用状态" clearable @change="changeQuery">
                        <el-option label="未使用" :value="0"></el-option>
                        <el-option label="已使用" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <div style="float: right">
                    <el-button type="primary" @click="changeQuery()">搜索</el-button>
                </div>
            </el-form>
            <div class="action">
                <el-button type="primary" @click="add()">新增卡券</el-button>
                <el-upload style="display:inline-block;margin-left:10px" class="upload-demo" action="/i/admin/exchange/import" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" name="file" :headers="header">
                    <el-button size="small" type="success">表格导入</el-button>
                </el-upload>
                <el-button style="display:inline-block;margin-left:10px" type="primary" @click="exportExcel()">导出卡券</el-button>
            </div>
            <el-table v-loading="loading" :data="pageInfo.list" element-loading-text="数据加载中" stripe border ref="multipleTable">
                <el-table-column prop="ID" label="id" width="100" align="center"></el-table-column>
                <el-table-column prop="code" label="卡密编码" align="center" width="200"></el-table-column>
<!--
                <el-table-column prop="password" label="卡密" align="center" width="200"></el-table-column>
-->
                <el-table-column label="面额(元)" prop="amount" align="center" width="120">
                    <template slot-scope="scope">
                        {{scope.row.amount /100}}
                    </template>
                </el-table-column>
                <el-table-column label="有效期" prop="ctime" width="350" align="center">
                    <template slot-scope="scope">
                        {{scope.row.ctime}} - {{scope.row.etime}}
                    </template>
                </el-table-column>
                <el-table-column label="状态" prop="state" align="center">
                    <template slot-scope="scope">
                        <el-tag type="primary" v-if="scope.row.state === 2">有效</el-tag>
                        <el-tag type="warning" v-if="scope.row.state === 0">失效</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="使用状态" prop="usedState" align="center">
                    <template slot-scope="scope">
                        <el-tag type="warning" v-if="scope.row.usedState === 2" >已使用</el-tag>
                        <el-tag type="primary" v-if="scope.row.usedState === 0">未使用</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="冻结状态" prop="state" align="center">
                    <template slot-scope="scope">
                        <el-tag type="warning" v-if="scope.row.freezeState === 2">冻结</el-tag>
                        <el-tag type="primary" v-if="scope.row.freezeState === 0">未冻结</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="usedTime" label="领取时间" width="200" align="center"></el-table-column>
                <el-table-column prop="user" label="所属会员" width="200" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.user">  {{scope.row.user.phone}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="操作" align="center" width="170" fixed="right">
                    <template slot-scope="scope">
<!--                        <el-button type="text" icon="el-icon-edit" @click="edit(scope.$index, scope.row)">编辑</el-button>-->
                        <!-- <el-button v-if="scope.row.state === 2" type="text" class="red" @click="state(scope.row, 1)">下线
                        </el-button>
                        <el-button v-if="scope.row.state === 1" type="text" class="green" @click="state(scope.row, 2)">
                            上线</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <Pagination v-bind:pageInfo="pageInfo" v-on:refreshPageSize="refreshPageSize" v-on:refreshPageNum="refreshPageNum" />
        </div>
        <!-- 新增 编辑 -->
        <el-dialog :title="title" :visible.sync="addVisible" width="600px" v-if="addVisible" class="dialog_box">
            <el-form ref="form" :model="form" label-width="120px" :rules="rules" label-position="right">

                <!-- 兑换码 -->
                <el-form-item label="兑换码" prop="code">
                    <el-input v-model="form.code" placeholder="请输入兑换码"></el-input>
                </el-form-item>

                <!-- 兑换密钥 -->
                <el-form-item label="兑换密钥" prop="password">
                    <el-input v-model="form.password" placeholder="请输入兑换密钥"></el-input>
                </el-form-item>

                <!-- 领取使用方式 -->
                <el-form-item label="领取使用方式" prop="usedMethod">
                    <el-select v-model="form.usedMethod" placeholder="请选择领取方式">
                        <el-option label="券密兑换" :value="0"></el-option>
                    </el-select>
                </el-form-item>

                <!-- 有效期 -->
                <el-form-item label="有效期" prop="timeRange">
                    <el-date-picker
                        v-model="form.timeRange"
                        type="datetimerange"
                        value-format="timestamp"
                        range-separator="至"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间">
                    </el-date-picker>
                </el-form-item>

                <!-- 金额 -->
                <el-form-item label="金额(分)" prop="amount">
                    <el-input-number v-model="form.amount" :min="0" :step="100" step-strictly></el-input-number>
                    <span style="margin-left:10px;">元</span>
                </el-form-item>

                <!-- 状态 -->
                <el-form-item label="状态" prop="state">
                    <el-radio-group v-model="form.state">
                        <el-radio :label="2">有效</el-radio>
                        <el-radio :label="0">失效</el-radio>
                    </el-radio-group>
                </el-form-item>

                <!-- 冻结状态 -->
                <el-form-item label="冻结状态" prop="freezeState">
                    <el-radio-group v-model="form.freezeState">
                        <el-radio :label="2">冻结</el-radio>
                        <el-radio :label="0">未冻结</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                    <el-button @click="addVisible = false">取 消</el-button>
                    <el-button type="primary" @click="saveData">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 删除 -->
        <el-dialog title="是否删除数据" :visible.sync="removeVisible" width="300px" center>
            <div class="del-dialog-cnt">删除后数据无法恢复，是否确认删除？</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="removeVisible = false">取 消</el-button>
                <el-button type="primary">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 上线、下线提示框 -->
        <el-dialog title="提示" :visible.sync="confirmVisible" width="300px" center>
            <div class="del-dialog-cnt">{{ confirmContent }}</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmVisible = false">取 消</el-button>
                <el-button type="primary" @click="stateData">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import Breadcrumb from '@/components/Breadcrumb';
import Pagination from '@/components/Pagination';
import loadEvents from '@/utils/loading'
import Url from '@/components/Url';
import {request} from '@/common/request';
import {deal} from '@/common/main';

let loads = new loadEvents();
export default {
    name: 'seller',
    components: {
        Breadcrumb,
        Pagination,
        Url
    },
    data() {
        return {
            multiple: false,
            imageUrl: '',
            header: {},
            menuList: ['营销', '卡密券码'],
            queryParams: {
                ctime: '',
                etime: '',
                page: 1,
                pagesize: 10,
                used_state: null,
                state: null,
            },
            //验证规则
            rules: {
                code: [{
                    required: true,
                    message: '兑换码不能为空',
                    trigger: 'blur'
                }],
                password: [{
                    required: true,
                    message: '兑换密钥不能为空',
                    trigger: 'blur'
                }],
                usedMethod: [{
                    required: true,
                    message: '请选择领取使用方式',
                    trigger: 'change'
                }],
                timeRange: [{
                    required: true,
                    message: '请选择有效期',
                    trigger: 'change'
                }],
                amount: [{
                    required: true,
                    message: '金额不能为空',
                    trigger: 'blur'
                },
                    {
                        pattern: /^[0-9]*$/,
                        message: "只能输入数字"
                    }]
            },
            form: {
                code: '',
                password: '',
                usedMethod: 1, // 默认为券密兑换
                timeRange: [],
                ctime: 0,
                etime: 0,
                amount: 0,
                state: 2, // 默认有效
                freezeState: 0 // 默认未冻结
            },
            loading: false,
            pageInfo: {},
            addVisible: false,
            removeVisible: false,
            confirmVisible: false,
            confirmContent: '',
            title: '加载中',
            mode: 'add',
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            }
        };
    },
    created() {
        this.header.token = localStorage.getItem('token');
        this.header.platform = 'admin';
        this.loadData();
    },
    methods: {
        // 卡券活动列表
        loadData() {
            this.loading = true;
            request.get('/exchange/list', this.queryParams).then(ret => {
                if (ret.code == 1) {
                    this.loading = false;
                    this.pageInfo = ret.data;
                    this.pageInfo.list = ret.data.list;
                    this.pageInfo.list.map(function (val) {
                        val.ctime = deal.timestamp(val.ctime, 'unix');
                        val.etime = deal.timestamp(val.etime, 'unix');
                        if (val.usedTime && val.usedTime !== 0){
                            val.usedTime = deal.timestamp(val.usedTime, 'unix');
                        }else {
                            val.usedTime = '未领取';
                        }

                        return val;
                    })
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        //分页
        changeQuery() {
            this.queryParams.page = 1;
            this.loadData();
        },
        refreshPageSize(val) {
            this.queryParams.pagesize = val;
            this.loadData();
        },
        refreshPageNum(val) {
            this.queryParams.page = val;
            this.loadData();
        },
        //新增
        add() {
            this.mode = 'add';
            this.title = '新增卡券';
            this.form = {
                state: 2
            };
            this.multiple = true
            this.addVisible = true;
            if (this.$refs.form) {
                this.$refs.form.clearValidate()
            }
        },
        exportExcel(){
            this.loading = true;
            request.post('/exchange/export', this.queryParams).then(ret => {
                if (ret.code == 1) {
                    this.loading = false;
                    this.$message.success('导出成功');
                } else {
                    this.$message.error(ret.msg);
                }
            });
            setTimeout(() => {
                this.loading = false;
            }, 3000);
        },
        //编辑
        edit(index, row) {
            this.mode = 'edit';
            this.title = '编辑卡券';
            this.multiple = false;
            this.current = row.id;

            const item = this.pageInfo.list[index];

            // 处理时间字段：将时间字符串转换为时间戳（秒）
            let timeRange = [];
            if (item.ctime) {
                // 如果是格式化后的时间字符串，先转成Date对象再获取时间戳
                 // 转为秒
                timeRange[0] = new Date(item.ctime).getTime();
            }

            if (item.etime) {
                 // 转为秒
                timeRange[1] = new Date(item.etime).getTime();
            }

            // 设置表单数据
            this.form = Object.assign({}, item);
            this.$set(this.form, 'timeRange', timeRange); // 使用Vue.set确保响应式更新
            this.$set(this.form, 'amount', item.amount / 100);

            this.addVisible = true;

            // 清除验证
            if (this.$refs.form) {
                this.$refs.form.clearValidate();
            }
        },

        //状态
        state(row, state) {
            if (state == 2) {
                this.confirmContent = '确定是否上线?';
            } else {
                this.confirmContent = '确定是否下线?';
            }
            this.form = Object.assign({}, row);
            this.form.state = state;
            this.form.ctime = deal.timestamp(this.form.ctime);
            this.form.etime = deal.timestamp(this.form.etime);
            this.confirmVisible = true;
        },
        //增加编辑
        saveData() {
            if (this.$refs.form) {
                this.$refs.form.validate(valid => {
                    if (valid) {
                        // 处理时间范围
                        if (this.form.timeRange && this.form.timeRange.length === 2) {
                            this.form.ctime = this.form.timeRange[0];
                            this.form.etime = this.form.timeRange[1];
                        }

                        var url = this.mode === 'add' ? '/exchange/add' : '/exchange/edit';

                        request.post(url, this.form).then(ret => {
                            if (ret.code == 1) {
                                this.addVisible = false;
                                this.loadData();
                                this.$message.success((this.mode == 'add' ? '新增' : '编辑') + '成功');
                                this.$refs.form.clearValidate()
                            } else {
                                this.$message.error(ret.msg);
                            }
                        });
                    } else {
                        this.$message.error('请补全信息');
                        return false;
                    }
                });
            }
        },
        // 确定下线
        stateData() {
            request.post('/wallet/activity/edit', this.form).then(ret => {
                if (ret.code == 1) {
                    this.$message.success('操作成功');
                    this.loadData();
                    this.confirmVisible = false;
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        handleAvatarSuccess(res, file) {
            if (res.code === 1) {
                loads.close()
                this.loadData();
                console.log("上传成功")
            }
        },
        beforeAvatarUpload(file) {
            let fileName = file.name
            let pos = fileName.lastIndexOf('.')
            let lastName = fileName.substring(pos, fileName.length)
            if (lastName.toLowerCase() !== '.xlsx') {
                this.$message.error('不支持此文件格式!');
            }
            loads.open(`body`, '导入中');
        },
    }
};
</script>
<style scoped>
.red {
    color: #ff0000;
}

.green {
    color: green;
}
/* 对话框样式 */

.dialog_box >>> .el-dialog__body {
    padding: 20px 30px 20px 60px;
}

.dialog_box >>> .el-dialog__header {
    padding: 30px 30px 10px;
}

.dialog_box .el-form-item--small.el-form-item {
    margin-bottom: 20px;
}
</style>